import { emitter } from 'shared/helpers/mitt';

export const forwardLogic = {
  data() {
    return {
      isForwardModalOpen: false,
      selectedMessages: [],
      _dexOpenForwardModal: null,
      _dexForwardMessage: null
    }
  },

  mounted() {
    this._dexOpenForwardModal = (event) => {
      const payload = event.detail
      this.isForwardModalOpen = true
      console.log('dex-open-forward-modal:', { conversationId: payload.conversationId, selectedMessages: this.selectedMessages, isForwardModalOpen: this.isForwardModalOpen })
    }

    emitter.on(
      'dex-open-forward-modal',
      this._dexOpenForwardModal
    )

    this._dexForwardMessage = (event) => {
      console.log('dex-forward-message:', event.detail)
      const payload = event.detail
      if (payload?.checked) {
        this.selectedMessages.push(payload)
      } else {
        this.selectedMessages = this.selectedMessages.filter(
          (f) =>
            f.messageId !== payload.messageId ||
            f.conversationId !== payload.conversationId
        )
      }
      console.log('dex-forward-message-selected:', this.selectedMessages)
    }

    emitter.on(
      'dex-forward-message',
      this._dexForwardMessage
    )
  },

  beforeUnmount() {
    emitter.all.clear()
  },

  methods: {
    clearSelection() {
      this.selectedMessages = []
      this.isForwardModalOpen = false
    }
  }
}
